import React, { useState } from "react";
import Image from "react-bootstrap/Image";

const ExpertAssignList = ({
  experts = [],
  assignedExperts = [],
  setFieldValue,
  fieldName = "expertiseAssign",
  isRadio = false,
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  // Normalize expert object to always have id, email, profilePic, firstName, lastName
  const normalizeExpert = (expert) => ({
    id: expert.id || null,
    email: expert.email || null,
    profilePic: expert.profilePic || `https://ui-avatars.com/api/?name=${expert.firstName}+${expert.lastName}&background=007bff&color=fff&size=100`,
    firstName: expert.firstName || "",
    lastName: expert.lastName || "",
  });

  const expertIds = experts.map((e) => e.id).filter(Boolean).sort();
  const assignedIds = assignedExperts.map((e) => e.id).filter(Boolean).sort();
  // ✅ Check if all experts are selected
  const isAllSelected =
    !isRadio &&
    experts.length > 0 &&
    experts.every((expert) =>
      assignedExperts.some((ae) => ae.id === expert.id)
    );

  // ✅ Toggle individual expert
  const toggleExpert = (expert) => {
    const e = normalizeExpert(expert);

    if (isRadio) {
      if (fieldName) setFieldValue(fieldName, [e]);
      else setFieldValue([e]);
      return;
    }

    const exists = assignedExperts.some((ae) => ae.id === e.id);

    const updated = exists
      ? assignedExperts.filter((ae) => ae.id !== e.id)
      : [...assignedExperts, e];

    if (fieldName) setFieldValue(fieldName, updated);
    else setFieldValue(updated);
  };

  // ✅ Handle Select All checkbox
  const handleSelectAll = (isChecked) => {
    if (isRadio) return;

    const updated = isChecked ? experts.map(normalizeExpert) : [];
    if (fieldName) setFieldValue(fieldName, updated);
    else setFieldValue(updated);
  };

  const filteredExperts = experts.filter((expert) => {
    const first = expert.firstName?.toLowerCase() || "";
    const last = expert.lastName?.toLowerCase() || "";
    const fullName = `${first} ${last}`;
    const fullNameNoSpace = fullName.replace(/\s+/g, "");
    const normalizedSearch = searchTerm.toLowerCase().trim();
    const tokens = normalizedSearch.split(/\s+/).filter(Boolean);
    const searchNoSpace = normalizedSearch.replace(/\s+/g, "");

    return (
      tokens.some(
        (token) =>
          first.includes(token) ||
          last.includes(token) ||
          fullName.includes(token)
      ) || fullNameNoSpace.includes(searchNoSpace)
    );
  });

  return (
    <>
      <input
        type="text"
        className="form-control form-control-search"
        aria-label="Search Input"
        placeholder="Search here..."
        autoComplete="off"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <div className="expertise-list mt-3">
        {!isRadio && (
          <div className="expertise-item">
            <label className="form-check-label align-items-center" htmlFor="select-all">
              <input
                className="form-check-input me-3"
                type="checkbox"
                id="select-all"
                checked={isAllSelected}
                onChange={(e) => handleSelectAll(e.target.checked)}
              />
              Select All
            </label>
          </div>
        )}

        {filteredExperts.map((expert, index) => {
          const isChecked = assignedExperts.some(
            (ae) => (ae.id && ae.id === expert.id) || (ae.email && ae.email === expert.email)
          );

          return (
            <div className="expertise-item" key={expert.id || expert.email || index}>
              <label className="form-check-label align-items-center" htmlFor={`expert-${index}`}>
                <input
                  className="form-check-input me-3"
                  type={isRadio ? "radio" : "checkbox"}
                  id={`expert-${index}`}
                  name={isRadio ? "expert-radio" : `expert-${index}`}
                  checked={isChecked}
                  onChange={() => toggleExpert(expert)}
                />
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    overflow: "hidden",
                  }}
                  className="me-2"
                >
                  <Image
                    src={expert.profilePic || "/images/user-circle.svg"}
                    alt="Expert"
                    width="40"
                    height="40"
                    style={{ objectFit: "cover", width: "100%", height: "100%" }}
                  />
                </div>

                {expert.firstName + " " + expert.lastName}
              </label>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default ExpertAssignList;
